import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { t } from 'i18next';
import { ColumnCustomProps } from 'components/DataGridCustom';
import { SvgIcon } from '@progress/kendo-react-common';
import { Dialog, Window } from '@progress/kendo-react-dialogs';
import { Trans } from 'react-i18next';
import { CommonLibrary } from 'contexts/CommonContext';
import { ProjectModel } from '@launchmetrics/dmr-header-component/src/Model/project-model';
import { Button } from '@progress/kendo-react-buttons';
import { Link } from 'react-router-dom';
import * as svgIcons from "@progress/kendo-svg-icons";
import ProjectNotificationEmailService, { ProjectNotificationEmailModel } from '../../../services/ProjectNotificationEmailsService';
import DataGridCustomCS from 'components/DataGridCustomCS';


function ProjectNotificationEmails() {    
  const projectNotificationEmailService = new ProjectNotificationEmailService();
  const [data, setData] = React.useState<ProjectNotificationEmailModel[]>();
  const comonLibrary = new CommonLibrary();
  const [selectedProject] = React.useState<ProjectModel | undefined>(comonLibrary.ActiveProject);
  const [selectedRow, setSelectedRow] = React.useState<any>(null);
  const [showDialog, setShowDialog] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);

  
  const fetchData = async () => {
        const result = await projectNotificationEmailService.GetProjectNotificationEmails();
        setData(result);        
    };
     React.useEffect(() => {
            fetchData();
        }, []);

  function handleRowClick(dataItem: any): void {
    setSelectedRow(dataItem);
    setShowDialog(true);
  }
  function handleDeleteClick(dataItem: any): void {
    setSelectedRow(dataItem);
    setShowDelete(true);
    
  }
  function CloseDeleteDialog(): void {
    setShowDelete(false);
  }
  function handleDelete(): void {
    if (selectedRow?.Id) {
      projectNotificationEmailService.DeleteAnnotation(selectedRow.Id)
      .then(() => {
        setShowDelete(false);
        fetchData();  
      })
    }
  }

    
  function handleAdd(): void {
    setSelectedRow(null);
    setShowDialog(true);
  }
  const handleDialogClose = () => {
    setShowDialog(false);
    setSelectedRow(null);
  };
  const commandCell = (props: any) => (
          <td style={{ textAlign: "center" }}>
          <span className="button-grid">
            <Button
            themeColor="primary"
            className='mx-2'
            onClick={() => handleRowClick(props.dataItem)}
            >
            <Trans>general.edit</Trans> 
            </Button>
            
            <Button
            themeColor="primary"
            onClick={() => handleDeleteClick(props.dataItem)}
            >
            <Trans>general.delete</Trans> 
            </Button>
          </span>
          </td>
        );

    const columns = [] as ColumnCustomProps[];
    columns.push({ 
        field: "Email", 
        title: t("general.email"), 
        columnMenu: undefined, 
        isExportable: true, 
        filterable: false,
    });  
    columns.push({ cell: commandCell, width: "200px", isExportable: false });

    return (
        <>
          <Col className="g-4 px-4" style={{ padding: "20px" }}>
            <Row className="border g-4 px-4 m-4 rounded tile-content py-3 my-4 d-flex flex-column ">
              <Container >
                <div>
                <Row className="filter-content">
                  <Col md={10}>
                    <h5 className="title">                
                    {selectedProject?.Description}{" "}
                        <Trans>configuration.projects.notificationEmails</Trans>
                    </h5>
                  </Col>
                  <Col md={2}>
                    <div className="space-between">
                      <Link className="btn" to="/DataLabeling/project" onClick={(e) => {
                        e.preventDefault();
                        window.location.href = "/DataLabeling/project";
                      }}>
                        <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" /><Trans>general.returnToBack</Trans>
                      </Link>
                    </div>
                  </Col>
                </Row>
                </div>
              </Container>
            </Row>
            <Row className="row g-4 m-4 px-4 tile-content border rounded" style={{ marginTop: '4rem' }} >
              <DataGridCustomCS
                ShowRemoveButton={false}
                ShowExportButton={false}
                ShowAddButton={true}
                onAddButtonClick={() => {handleAdd()}}
                dataSource={[...(data || [])]} 
                DataItemKey="Id"
                Columns={columns} 
                ShowCustomButton={false}
                PageSize={15}
                PermissionButtonCode='menu_projects'
              />
            </Row>
            {showDialog && 
              <Window
              title={selectedRow?.Id ? t("configuration.projects.editNotificationEmail") : t("configuration.projects.addNotificationEmail")}
              initialHeight={200}
              initialWidth={400}
              onClose={handleDialogClose}>
                <form
                  onSubmit={(e) => {
                  e.preventDefault();
                  // Handle submit logic here
                  setSelectedRow(null);
                  handleDialogClose();
                  if (selectedRow?.Id) {
                    projectNotificationEmailService.UpdateProjectEmail(selectedRow)
                      .then(() => {
                        fetchData();
                      })
                  } else {
                    projectNotificationEmailService.AddProjectEmail(selectedRow)
                      .then(() => {
                        fetchData();
                      })
                  }}}
                >
                <div className="form-group">
                  <label htmlFor="email">{t("general.email")}</label>
                  <input
                    id="email"
                    type="email"
                    className="form-control"
                    value={selectedRow?.Email || ""}
                    onChange={(e) =>
                      setSelectedRow({ ...selectedRow, Email: e.target.value, Id: selectedRow?.Id || 0, ProjectId: selectedProject?.Id }) // Ensure Id is explicitly set
                    }
                    required
                  />
                </div>
                <div className="form-group k-dialog-buttons d-flex justify-content-between" style={{ position: "absolute", bottom: "20px", width: "90%" }}>
                  <Button type="submit" themeColor="primary">
                  <Trans>general.submit</Trans>
                  </Button>
                  <Button onClick={handleDialogClose}>
                  <Trans>general.cancel</Trans>
                  </Button>
                </div>
              </form>
              </Window>
            }
            {showDelete && (
                    <Dialog title={t("general.confirmAction")} onClose={CloseDeleteDialog}>
                      <p><Trans>configuration.projects.deleteNotificationEmail</Trans></p>
                      <div className="k-dialog-buttons d-flex justify-content-between">
                        <Button themeColor="primary" onClick={handleDelete}>
                          <Trans>general.delete</Trans>
                        </Button>
                        <Button onClick={CloseDeleteDialog}>
                          <Trans>general.cancel</Trans>
                        </Button>
                      </div>
                    </Dialog>
                )} 
          </Col>
        </>
      );
};

export default ProjectNotificationEmails;
